import { type IService, ServiceFormats, ServiceSeatsPaymentTypes, ServiceTypes } from '@types';

export function getPlacesData(service: IService) {
  let min = 1
  let max = Infinity
  let includedSeats = 0
  let additionalSeats = 0
  let price = 0
  switch (service.type) {
    case ServiceTypes.Rent: {
      max = +service.seats
      switch (service.format) {
        case ServiceFormats.timeAndPlace: {
          includedSeats = +service.includedSeats
          additionalSeats = +service.additionalSeats
          max = Math.min(+service.seats, includedSeats + additionalSeats)
          price = +service.additionalSeatsAmount
          break
        }
      }
      break
    }
    case ServiceTypes.GroupService: {
      min = 1
      max = +service.seats || 1
      break
    }
    case ServiceTypes.Individual: {
      max = +service.amountPeopleMax
      min = +service.amountPeopleMin
      break
    }
  }

  if (max < 1) max = 1;

  const smartPrice = ({duration = 0}) => {
    switch (service.additionalSeatsPaymentType) {
      case ServiceSeatsPaymentTypes.time: {
        return price * (duration / 60)
      }
      default: return price
    }
  }

  return {
    min,
    max,
    price,
    includedSeats,
    smartPrice
  }
}